import pressureWashing from './assets/Services/pressure-washing.jpg';
import fleetCleaning from './assets/Services/fleet-cleaning.jpg';
import heavyEquipCleaning from './assets/Services/heavy-equipment-cleaning.jpg';
import houseCleaning from './assets/Services/house-cleaning.jpg';
import driveWayCleaning from './assets/Services/driveway-cleaning.jpg';
import parkadeCleaning from './assets/Services/parkade-cleaning.jpg';
import commercialCleaning from './assets/Services/commercial-cleaning-services.jpg';
import windowCleaning from './assets/Services/window-cleaning.jpg';
import gutterCleaning from './assets/Services/gutter-cleaning.jpg';
import graffitiCleaning from './assets/Services/graffiti-removal.jpg';
import sanitizationAndCleaning from './assets/Services/interior-sanitization-and-cleaning.jpg';
import airConCleaning from './assets/Services/air-conditioner-cleaning.jpg';


const SiteText = {
    Global:{
        GetQuote: "Get Quote",
        Name: "Elite Power Wash",
        Contact:{
            Email: "info@elitepowerwash.com",
            Phone: "(204)-996-7396",
            Address: {
                Street1: "911 Lagimodiere Blvd",
                City: "Winnipeg",
                State: "Manitoba",
                PostalCode: "R2J0V1",
            }
        }
    },
    SitePaths:{
        Home: "/",
        About: "/about-us",
        GetQuote: "/contact",
        ServiceId: "/services/:id",
        Service: "/services/",
    },
    Hero:{
        Title: "Your Power Wash Professionals",
        SubTitle: "Taking Cleanliness a Step Further",
        Description: () => `Whether you need pressure washing services for your residential property or commercial space, ${SiteText.Global.Name} will do it at very competitive rates!`,
    },
    NavBar:{
        Bottom:{
            Home: "Home",
            Services:{
                Title: "Services",
                DropDownMenuText: {}
            },
            GetQuote: "Contact Us",
            AboutUs: "About Us",
        }
    },
    Footer: {
        WorkHours: [
            "Monday to Saturday",
            "8am to 8pm"
        ]
    },
    Quote:{
        Title: "Request Your Quote",
        Submit: "Submit",
        Error: "Looks like some information needs your attention. Please review your details.",
        Fields:{
            Name:{
                FormName: "name",
                PlaceHolder: "Enter your name"
            },
            Email:{
                FormName: "email",
                PlaceHolder: "Enter your email"
            },
            PhoneNumber:{
                FormName: "phoneNumber",
                PlaceHolder: "Enter your phone number",
            },
            Address:{
                //Below is a way for us to autocomplete the address
                //https://www.canadapost-postescanada.ca/ac/
                FormName: "Address",
                PlaceHolder: "Address of project",
            },
            AdditionalInfo:{
                FormName: "additionalInfo",
                PlaceHolder: "Tell us how we can help"
            }
        },
    },
    Description:{
        Title: "About Us",
        Paragraph: [
            "Maintaining a spotless home or business is a key priority in the services we provide. Before beginning any project, we carefully treat all surfaces with a disinfectant and algae remover to ensure a thorough and effective clean.",
            "Our 24/7 flexible scheduling means we work when you need us, minimizing disruptions to your business or home. From fleet owners and construction teams to homeowners and short-term rental hosts, we’re the trusted choice for a superior, hassle-free clean—every time.",
        ],
        Socials: {
            FollowMesseage: "Follow us on: ",
            Links: {
                Facebook: "https://www.facebook.com/profile.php?id=61580422312473",
                Instagram: "https://www.instagram.com/elitepowerwash_wpg/"
            }
        }
    },
    Gratitude:[
        "Thank You for contacting us!",
        "One of our staff members will be in contact with you shortly",
    ],
    Services:{
        Data:{
            PressureWashing: {
                Title: "Pressure Washing",
                Image: pressureWashing,
                DescriptionShort: "Do you want your driveway to dazzle or your deck to delight? Then we are here to serve you!",
                DescriptionLong: "If you're ready to stop spending your valuable time on tedious cleaning tasks, our professional and reliable pressure washing service in Winnipeg is here to help. We eliminate the hassle of exterior maintenance, allowing you to focus on what matters most—whether that’s spending time with family, pursuing hobbies, or managing your daily responsibilities. With our commitment to excellence and a 100% satisfaction guarantee, you can trust that your property will be cleaned to the highest standards while you enjoy peace of mind.",
            },
            FleetCleaning: {
                Title: "Fleet Cleaning",
                Image: fleetCleaning,
                DescriptionShort: "Keep your fleet looking professional and performing at its best with our thorough mobile washing services",
                DescriptionLong: "Your company vehicles are a moving advertisement for your business, and their appearance directly impacts how customers perceive you. Our Fleet Cleaning service provides reliable, high-quality washing for trucks, vans, buses, and service vehicles. We remove dirt, road grime, salt, and grease that can cause long-term damage if left untreated. With flexible scheduling and mobile service options, we make it easy to keep your fleet spotless, ensuring your vehicles not only look great but also last longer. Trust us to keep your business moving forward, clean and professional.",
            },
            HeavyEquipCleaning: {
                Title: "Heavy Equipment Cleaning",
                Image: heavyEquipCleaning,
                DescriptionShort: "High-pressure washing for construction and industrial machinery to remove mud, oil, and debris",
                DescriptionLong: "Keeping your heavy equipment and commercial vehicles clean is crucial for optimal performance, safety, and long-term durability. At Elite Pressure Wash, we specialize in pressure washing, steaming, and interior sanitization for heavy machinery, construction equipment, trailers, and fleet vehicles throughout Winnipeg and across Manitoba— Our services are tailored to meet the needs of construction firms, trucking companies, industrial operations, and fleet managers who require dependable, high-quality cleaning solutions. We effectively remove dirt, grease, grime, and other contaminants to keep your equipment operating at its best. Contact us today to book your next cleaning service.",
            },
            HouseCleaning: {
                Title: "House Cleaning",
                Image: houseCleaning,
                DescriptionShort: "A sparkling clean home without the stress—let us handle the mess so you can enjoy your space",
                DescriptionLong: "Our House Cleaning service is designed to give you a spotless, fresh, and welcoming home without the hassle of spending your weekends scrubbing and dusting. From kitchens and bathrooms to living rooms and bedrooms, our team tackles dirt, dust, and buildup with care and precision. We use safe and effective cleaning products, paying attention to the details that make a difference. Whether you need a one-time deep clean or recurring maintenance, we create a customized plan that suits your lifestyle. Enjoy more time with your family and less time worrying about chores with our professional house cleaning service.",
            },
            DriveWay: {
                Title: "Drive Way Cleaning",
                Image: driveWayCleaning,
                DescriptionShort: "Restore your driveway’s curb appeal by removing stains, dirt, and buildup with powerful pressure washing",
                DescriptionLong: "Over time, driveways collect oil stains, dirt, tire marks, moss, and other stubborn buildup that can make your property look aged and neglected. Our Driveway Cleaning service uses high-powered pressure washing to strip away grime and restore your driveway’s original appearance. Regular cleaning not only enhances curb appeal but also helps protect against surface damage caused by contaminants. Whether concrete, brick, or stone, we ensure your driveway is left spotless, safe, and welcoming for both residents and guests.",
            },
            ParkadeCleaning:{
                Title: "Parkade Cleaning",
                Image: parkadeCleaning,
                DescriptionShort: "Comprehensive cleaning for parkades and garages to ensure safety, cleanliness, and a professional appearance",
                DescriptionLong: "Parkades are high-traffic areas that quickly accumulate dirt, oil, salt, debris, and other contaminants that can damage surfaces and create safety hazards. Our Parkade Cleaning service provides complete cleaning solutions for underground and above-ground parking structures. We use high-pressure washing and specialized equipment to remove grime, stains, and hazardous buildup, improving both aesthetics and safety. Regular cleaning helps extend the life of your surfaces, prevent slips and falls, and maintain a professional image for your property or business.",
            },
            CommercialCleaning:{
                Title: "Commercial Cleaning Services",
                Image: commercialCleaning,
                DescriptionShort: "Professional cleaning solutions to keep your workplace safe, spotless, and welcoming for employees and clients",
                DescriptionLong: "A clean workspace isn’t just about appearances—it’s essential for health, safety, and productivity. Our Commercial Cleaning Services are tailored to meet the needs of offices, retail spaces, warehouses, and industrial facilities across Winnipeg. We handle everything from floor care and sanitation to pressure washing and interior cleaning, ensuring your business environment remains spotless and professional. With flexible scheduling, eco-friendly cleaning methods, and a commitment to quality, we help you create a cleaner, healthier, and more inviting space for staff and customers alike.",
            },
            WindowCleaning: {
                Title: "Window Cleaning",
                Image: windowCleaning,
                DescriptionShort: "We use tried and tested methods to banish dirt, remove marks, and leave your windows looking as immaculate as the day they were installed",
                DescriptionLong: "Without regular cleaning, windows can accumulate dirt, dust, debris, and organic growth—all of which can compromise their condition and lead to long-term damage. By choosing our professional window cleaning services, you can be confident that your windows will be thoroughly maintained and protected from harmful buildup. Proper care not only enhances their appearance but also extends their lifespan, reducing the need for costly repairs and saving you money over time.\nUsing high-quality equipment and proven methods, we deliver crystal-clear results every time.",
            },
            GutterCleaning: {
                Title: "Gutter Cleaning",
                Image: gutterCleaning,
                DescriptionShort: "Trust us to get rid of blockages and brighten your gutters, leaving them fit for purpose and looking better than ever",
                DescriptionLong: "We ensure two things: safety and efficiency when it comes to your Gutter Cleaning. When gutters become full of debris, they prevent water from draining, allowing moss, mould and unwanted plant growth as well as insect and rodent infestation. Our Gorilla Technicians ensure that the job is done properly by using a three-step system for Gutter Cleaning.",
            },
            GrafittiRemoval: {
                Title: "Graffiti Removal",
                Image: graffitiCleaning,
                DescriptionShort: "Fast and effective removal of graffiti to restore surfaces and protect your property’s image",
                DescriptionLong: "Unwanted graffiti can leave your property looking neglected and unprofessional while potentially encouraging further vandalism. Our Graffiti Removal service uses specialized cleaning agents and pressure washing techniques to safely and effectively remove paint, markers, and other graffiti from brick, stone, concrete, metal, and signage. We work quickly to restore your surfaces while minimizing damage to the underlying material. Protect your property’s image and maintain a clean, welcoming environment with our reliable graffiti removal solutions.",
            },
            InteriorCleaning: {
                Title: "Interior Sanitization and cleaning",
                Image: sanitizationAndCleaning,
                DescriptionShort: "Deep cleaning and sanitization for interiors to ensure a hygienic, safe, and professional environment",
                DescriptionLong: "Our Interior Sanitization and Cleaning service is ideal for truck boxes, van trailers, warehouses, storage areas, and other commercial or industrial spaces. We go beyond surface cleaning to disinfect and sanitize, targeting germs, bacteria, and contaminants that compromise hygiene and safety. Using industry-grade equipment and safe disinfectants, we provide a deep clean that enhances cleanliness and promotes a healthier environment for staff, clients, or transported goods. Trust us to restore freshness, cleanliness, and peace of mind inside your space.",
            },
            AirConCleaning: {
                Title: "Residential and Commercial Air Conditioner Cleaning",
                Image: airConCleaning,
                DescriptionShort: "Improve air quality, boost efficiency, and extend the life of your AC system with our expert cleaning service",
                DescriptionLong: "Dust, dirt, and debris buildup inside your air conditioner can reduce airflow, increase energy bills, and circulate allergens throughout your space. Our Air Conditioner Cleaning service is available for both residential and commercial units in Winnipeg, helping you maintain a healthier indoor environment. We carefully clean coils, filters, vents, and other components to improve cooling efficiency, enhance air quality, and extend the life of your AC system. Regular cleaning reduces breakdowns and ensures your system runs smoothly, saving you money and keeping your space comfortable year-round.",
            },
        },
        DataArray:{},
        MoreInfo: "For more info, click here",
    },
};

// Auto-generate NavBar.Bottom.Services.DropDownMenuText from Services.Data
SiteText.NavBar.Bottom.Services.DropDownMenuText = {
    ...SiteText.NavBar.Bottom.Services.DropDownMenuText,
    ...Object.fromEntries(Object.entries(SiteText.Services.Data).map(([key, value]) => [key, value.Title]))
};

SiteText.Services.DataArray = [
    ...Object.values(SiteText.Services.Data).map(
        (value) => ({
            id: value.Title.replaceAll(" ", "-").toLowerCase(),
            title: value.Title,
            image: value.Image,
            descriptionShort: value.DescriptionShort,
            descriptionLong: value.DescriptionLong,
        })
    )
];

export default SiteText;